module.exports = __webpack_public_path__ + "media/app/assets/imgs/sphir-colored-logo-e1f743d38eaef9411003f1df0e089a4e.svg";